import { render } from "./ClientPersonalnfo.vue?vue&type=template&id=2972b555&scoped=true"
import script from "./ClientPersonalnfo.vue?vue&type=script&lang=js"
export * from "./ClientPersonalnfo.vue?vue&type=script&lang=js"

import "./ClientPersonalnfo.vue?vue&type=style&index=0&id=2972b555&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2972b555"]])

export default __exports__